module.exports = __webpack_public_path__ + "img/streetmap.38bcf335.png";